export default __webpack_public_path__ + "static/media/articles_converted.bf8e32ff.jpg";